var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_vm._v("\n      "+_vm._s(_vm.isAT
          ? "Grupos de iniciativas"
          : _vm.isGov
          ? "Grupos de Fases"
          : "Grupos de soluções")+"\n      desabilitados\n    ")])],1),_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.solutionsGroup,"item-key":"name"},scopedSlots:_vm._u([{key:"item.acoes",fn:function({ item }){return [_c('AppModalRecoverGroup',{attrs:{"payload":{
              nomeGrupo: item.nome,
              municipioid: item.municipioId,
              municipiogruposolucaoid: item.municipioGrupoSolucaoId,
            }},on:{"onRecover":_vm.onRecoverM}})]}}])},[_c('template',{slot:"no-data"},[_c('div',[_vm._v("\n            Não há\n            "+_vm._s(_vm.isAT
                ? "Grupos de iniciativas"
                : _vm.isGov
                ? "Grupos de Fases"
                : "Grupos de soluções")+"\n            desabilitados\n          ")])])],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }